import { useCallback } from "react";

export interface BestTimeApi {
    check: (elapsedMs: number) => { isNewBest: boolean; prevExisted: boolean };
}

export const useBestTime = (storageKey: string): BestTimeApi => {
    const check = useCallback((elapsedMs: number) => {
        const prevBest = sessionStorage.getItem(storageKey);
        const prevExisted = prevBest !== null;
        if (!prevExisted || elapsedMs < parseFloat(prevBest as string)) {
            sessionStorage.setItem(storageKey, String(elapsedMs));
            return { isNewBest: true, prevExisted };
        }
        return { isNewBest: false, prevExisted };
    }, [storageKey]);

    return { check };
};
